import {
  IonButton,
  IonButtons,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCol,
  IonGrid,
  IonIcon,
  IonInput,
  IonItem,
  IonLabel,
  IonList,
  IonNote,
  IonRadio,
  IonRadioGroup,
  IonRange,
  IonRow,
  IonSelect,
  IonSelectOption,
  IonTitle,
} from "@ionic/react";
import { happyOutline, sadOutline, star, trash } from "ionicons/icons";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import FileUpload from "../../../components/FileUpload";
import Spacer from "../../../components/spacer";
import { getEntry, saveEntry } from "../../../services/users";
import { getImageURL } from "../../../services/util";
import EntryErrors from "./components/EntryErrors";
import FormNavigation from "./FormNavigation";

interface props {
  user: any;
  eid: any;
  dateTS: any;
}

const AddEditEntryEating: React.FC<props> = ({ user, eid, dateTS }) => {
  const history = useHistory();

  const defaultTargetFood = {
    food: "",
    amountOfferedQTY: "",
    acceptance: "",
    amountConsumedQTY: "",
    numberBitesConsumed: "",
  };

  // const defaultNightWakings = {
  // 	timeAwake: "",
  // 	duration: "",
  // };

  const defaultState = {
    eid: "",
    date: "",
    dateTS: "",
    page: 0,
    complete: false,
    meal: "breakfast",
    targetFood: [],
    mealtimeBehaviour: 1,
    imagePre: "",
    imagePost: "",
    imagePreURL: "",
    imagePostURL: "",
  };

  //const [user, setUser] = useState<any>({});
  const [entry, setEntry] = useState<any>(defaultState);
  const [setupComplete, setSetupComplete] = useState<any>(false);
  const [dates, setDates] = useState<any>([]);
  const [formErrors, setFormErrors] = useState<any>([]);

  const {
    date,
    page,
    complete,
    meal,
    targetFood,
    mealtimeBehaviour,
    imagePre,
    imagePost,
  } = entry;

  const _onChange = (e: any) => {
    if (setupComplete) {
      let name = e.target.name;
      let value = e.target.value;
      if (
        [
          "food",
          "amountOfferedQTY",
          "amountConsumedQTY",
          "acceptance",
          "numberBitesConsumed",
        ].includes(name)
      ) {
        let id = e.target.dataset.id;
        let TF = entry.targetFood;
        TF[id][name] = value;
        setEntry({ ...entry, targetFood: TF });
      } else {
        setEntry({ ...entry, [name]: value });
      }
    }
  };

  const onFileUpload = (upload: any) => {
    //console.log(upload);

    setEntry({
      ...entry,
      [upload.id]: upload.file.fullPath,
      [`${upload.id}URL`]: upload.file.downloadUrl,
    });
  };

  const _onSubmit = () => {
    let stepValid = _checkValid();

    if (stepValid) {
      _saveEntry({ ...entry, complete: true });
      history.push(`/users/${user.id}`);
    }
  };

  const _saveEntry = (data: any) => {
    saveEntry(user.id, data);
  };

  // useEffect(() => {
  // 	if (entry) {
  // 		console.log(entry);
  // 	}
  // }, [entry]);

  useEffect(() => {
    if (!user.id && user.uid) user.id = user.uid;
    if (user && user.id) {
      if (eid && eid !== "new") {
        getEntry(user.id, eid).then((doc) => {
          setEntry({ ...defaultState, ...doc });
          setSetupComplete(true);
        });
      }
      if (user.dates && Object.values(dates).length < 1) {
        getUserDates();
      }
    }
  }, [user, eid]);

  useEffect(() => {
    if (dates && dateTS && entry.date === "") {
      let today = new Date().getTime();
      setEntry({ ...entry, eid: today.toString(), dateTS, date: getDate() });
      setSetupComplete(true);
    }
  }, [dates]);

  /**
   * Create an array of objects which represent dates within phases and whether an entry is required
   */
  const getUserDates = () => {
    let response: any = [];
    let today = new Date().getTime();

    Object.values(user.dates).forEach((element: any) => {
      let status = "upcoming";
      let link = "upcoming";
      let date = element.timestamp;

      //Add another condition here to check if an entry exists for the date and add a link
      if (date <= today) {
        status = "overdue";
        link = "new";
      }

      response[date] = {
        ...element,
        status,
        link,
      };
    });
    setDates(response);
  };

  const getDate = () => {
    let res = "";
    if (dates[dateTS]) {
      let date = dates[dateTS];
      res = date.dateField;
    }
    return res;
  };

  const _compareAcceptance = (o1: any, o2: any, idx: any) => {
    return o1 === targetFood[idx]["acceptance"];
  };

  const _compareMeal = (o1: any, o2: any) => {
    return o1 === meal;
  };

  const _onSelect = (e: any) => {
    console.log("select");
    let name = e.target.name;
    let value = e.target.value;
    let id = e.target.dataset.id;

    let TF = targetFood;

    if (name === "meal") {
      if (meal !== "") {
        setEntry({ ...entry, meal: value });
      }
    } else if (name === "acceptance") {
      TF[id]["acceptance"] = value;
      setEntry({ ...entry, targetFood: TF });
    }
  };

  const _onRangeChange = (e: any) => {
    let name = e.target.name;
    let value = e.detail.value as number;
    setEntry({ ...entry, [name]: value });
  };

  const _checkValid = () => {
    let errors: any = [];

    if (Object.values(targetFood).length === 0)
      errors.push("You must give details of foods");

    //let foodErrors = false;
    Object.values(targetFood).forEach((food: any, idx: any) => {
      if (!food.food || food.food === "")
        errors.push(`Food name required in Food Offered ${idx + 1}`);
      if (!food.amountOfferedQTY || food.amountOfferedQTY === "")
        errors.push(`Amount offered required in Food Offered ${idx + 1}`);
      if (!food.amountConsumedQTY || food.amountConsumedQTY === "")
        errors.push(`Amount consumed required in Food Offered ${idx + 1}`);
      if (!food.acceptance || food.acceptance === "")
        errors.push(
          `Please indicate level of acceptance of Food Offered ${idx + 1}`
        );
      if (!food.numberBitesConsumed || food.numberBitesConsumed === "")
        errors.push(`Bites consumed is required in Food Offered ${idx + 1}`);
    });
    setFormErrors(errors);

    return Object.values(errors).length === 0;
  };

  const changePage = (toPage: any) => {
    if (toPage > page) {
      let stepValid = _checkValid();

      if (stepValid) {
        setEntry({ ...entry, page: toPage });
        _saveEntry({ ...entry, page: toPage });
      }
    } else {
      setFormErrors([]);
      setEntry({ ...entry, page: toPage });
      //_saveEntry({ ...entry, page: toPage });
    }
  };

  const _addFood = (e: any) => {
    console.log(targetFood.length);
    if (targetFood.length < 5) {
      let array = targetFood;
      array.push(defaultTargetFood);
      setEntry({ ...entry, targetFood: array });
    }
  };

  const _removeFood = (i: number) => {
    let array = targetFood;
    array.splice(i, 1);
    setEntry({ ...entry, targetFood: array });
  };

  // const _onPhotoChange = (e: any) => {
  // 	setEntry({ ...entry, [e.name]: e.image.fullPath });
  // };

  return (
    <div className="content-wrapper">
      <Spacer size="60" />
      {setupComplete && (
        <>
          {dateTS && dates && dates[dateTS] && (
            <h1>Entry for {dates[dateTS].dateString}</h1>
          )}
          {dateTS && user.dates && (
            <IonInput
              name="date"
              value={date}
              type="date"
              hidden
              onIonChange={_onChange}
            />
          )}
          <FormNavigation
            page={page}
            setPage={changePage}
            onSubmit={_onSubmit}
            numPages={1}
          />
          <EntryErrors errors={formErrors} />
          <Spacer size="60" />
          {page === 0 && (
            <>
              <IonList>
                <IonItem lines="none">
                  <IonLabel position="stacked">Meal</IonLabel>
                  <IonSelect
                    compareWith={_compareMeal}
                    id="meal"
                    name="meal"
                    value={meal}
                    onIonChange={_onSelect}
                    okText="Okay"
                    cancelText="Dismiss"
                    placeholder="Select One"
                    interface="popover"
                  >
                    <IonSelectOption value="breakfast">
                      Breakfast
                    </IonSelectOption>
                    <IonSelectOption value="morningTea">
                      Morning Tea
                    </IonSelectOption>
                    <IonSelectOption value="lunch">Lunch</IonSelectOption>
                    <IonSelectOption value="afternoonTea">
                      Afternoon Tea
                    </IonSelectOption>
                    <IonSelectOption value="dinner">Dinner</IonSelectOption>
                    <IonSelectOption value="snack">Snack</IonSelectOption>
                  </IonSelect>
                </IonItem>
                <Spacer size="30" />

                <IonItem lines="none">
                  <IonLabel>Foods Offered</IonLabel>
                </IonItem>
                {Object.values(targetFood).length === 0 && (
                  <IonItem lines="none">
                    <IonNote>No foods specified</IonNote>
                  </IonItem>
                )}
                <div className="repeater-wrapper">
                  {Object.values(targetFood).map((food: any, idx: any) => {
                    //console.log(idx);
                    let foodID = `food-${idx}`,
                      amountOfferedQTYID = `amountOfferedQTY-${idx}`,
                      acceptanceID = `acceptance-${idx}`,
                      amountConsumedQTYID = `amountConsumedQTY-${idx}`,
                      numberBitesConsumedID = `numberBitesConsumed-${idx}`;
                    return (
                      <div key={idx}>
                        <IonCard className="repeater-card">
                          <IonCardHeader>
                            <IonItem lines="none">
                              <IonTitle>{`Food Offered ${idx + 1}`}</IonTitle>
                              <IonIcon
                                onClick={() => _removeFood(idx)}
                                icon={trash}
                                className="trash linked"
                              />
                            </IonItem>
                          </IonCardHeader>

                          <IonCardContent>
                            <IonItem>
                              <IonLabel position="floating">
                                Name of Food Offered
                              </IonLabel>
                              <IonInput
                                id={foodID}
                                name="food"
                                data-id={`${idx}`}
                                value={targetFood[`${idx}`].food}
                                onIonChange={_onChange}
                                placeholder="Food Name"
                              />
                            </IonItem>

                            <Spacer size="20" />

                            <IonItem>
                              <IonLabel position="stacked">
                                Amount Offered
                              </IonLabel>
                              <Spacer size="10" />
                              <IonNote>
                                Please provide an estimate of the total quantity
                                of food offered e.g. two slices of bread, 1/2 an
                                apple, 1 tablespoon of nutella, 1/2 cup of
                                orange juice
                              </IonNote>
                              <IonInput
                                id={amountOfferedQTYID}
                                name="amountOfferedQTY"
                                data-id={`${idx}`}
                                value={targetFood[`${idx}`].amountOfferedQTY}
                                onIonChange={_onChange}
                                type="text"
                              ></IonInput>
                            </IonItem>
                            <Spacer size="20" />

                            <IonItem>
                              <IonLabel position="stacked">
                                Amount Consumed
                              </IonLabel>
                              <Spacer size="10" />
                              <IonNote>
                                Please provide an estimate of the total quantity
                                of food consumed e.g. two slices of bread, 1/2
                                an apple, 1 tablespoon of nutella, 1/2 cup of
                                orange juice
                              </IonNote>
                              <IonInput
                                id={amountConsumedQTYID}
                                name="amountConsumedQTY"
                                data-id={`${idx}`}
                                value={targetFood[`${idx}`].amountConsumedQTY}
                                onIonChange={_onChange}
                                type="text"
                              ></IonInput>
                            </IonItem>

                            <Spacer size="20" />

                            <IonItem>
                              <IonLabel position="stacked">
                                General behaviour toward food
                              </IonLabel>
                              <IonSelect
                                compareWith={(currentValue, compareValue) =>
                                  _compareAcceptance(
                                    currentValue,
                                    compareValue,
                                    idx
                                  )
                                }
                                id={acceptanceID}
                                data-id={`${idx}`}
                                name="acceptance"
                                value={targetFood[`${idx}`].acceptance}
                                onIonChange={_onSelect}
                                okText="Okay"
                                cancelText="Dismiss"
                                placeholder="Select One"
                                interface="popover"
                              >
                                <IonSelectOption value="refused">
                                  Refused/spat out
                                </IonSelectOption>
                                <IonSelectOption value="accepted">
                                  Accepted into mouth
                                </IonSelectOption>
                                <IonSelectOption value="swallowed">
                                  Accepted then swallowed
                                </IonSelectOption>
                                <IonSelectOption value="consumed">
                                  Entire portion consumed
                                </IonSelectOption>
                              </IonSelect>
                            </IonItem>

                            <Spacer size="20" />

                            <IonItem>
                              <IonLabel position="stacked">
                                Number of bites consumed
                              </IonLabel>
                              <IonInput
                                id={numberBitesConsumedID}
                                name="numberBitesConsumed"
                                data-id={`${idx}`}
                                value={targetFood[`${idx}`].numberBitesConsumed}
                                onIonChange={_onChange}
                                type="number"
                              ></IonInput>
                            </IonItem>
                          </IonCardContent>
                        </IonCard>
                      </div>
                    );
                  })}
                  <Spacer size="20" />
                  <IonItem lines="none">
                    <IonButton size="default" onClick={_addFood}>
                      Add Food
                    </IonButton>
                  </IonItem>
                </div>

                <Spacer size="45" />
                <IonItem lines="none">
                  <IonLabel>Mealtime Behaviour</IonLabel>
                </IonItem>
                <IonItem lines="none">
                  <Spacer size="10" />
                  <IonNote>
                    1 = no problem behaviour/calm
                    <br />3 = some/moderate level of problem behahviour
                    <br />5 = extremely challenging/disruptive behaviour
                  </IonNote>
                </IonItem>
                <Spacer size="10" />
                <IonItem lines="none">
                  <IonRange
                    min={1}
                    max={5}
                    step={1}
                    id="mealtimeBehaviour"
                    name="mealtimeBehaviour"
                    value={mealtimeBehaviour ? mealtimeBehaviour : 1}
                    onIonChange={_onRangeChange}
                    snaps={true}
                    pin={true}
                  >
                    <IonIcon
                      slot="start"
                      size="large"
                      icon={happyOutline}
                    ></IonIcon>
                    <IonIcon
                      slot="end"
                      size="large"
                      icon={sadOutline}
                    ></IonIcon>
                  </IonRange>
                </IonItem>

                <Spacer size="30" />
                <IonItem lines="none">
                  <IonLabel>Photo of food before eating</IonLabel>
                </IonItem>
                <IonItem lines="none">
                  <FileUpload
                    name="imagePre"
                    id="imagePre"
                    value={imagePre}
                    onChange={onFileUpload}
                    pathPrefix={"feeding/"}
                  />
                </IonItem>
                <Spacer size="30" />
                <IonItem lines="none">
                  <IonLabel>Photo of food after eating</IonLabel>
                </IonItem>
                <IonItem lines="none">
                  <FileUpload
                    name="imagePost"
                    id="imagePost"
                    value={imagePost}
                    onChange={onFileUpload}
                    pathPrefix={"feeding/"}
                  />
                </IonItem>
              </IonList>
            </>
          )}
          <Spacer size="60" />
          <EntryErrors errors={formErrors} />
          <FormNavigation
            page={page}
            setPage={changePage}
            onSubmit={_onSubmit}
            numPages={1}
          />
          <Spacer size="90" />
        </>
      )}
    </div>
  );
};

export default AddEditEntryEating;
